import { defineComponent, computed } from '@vue/composition-api';
import __vue_component__ from '../SdsAlert/SdsAlert.vue.js';
import __vue_component__$1 from '../SdsIcon/SdsIcon.vue.js';

var idGenerator = 0;
var script = defineComponent({
    name: 'SdsCheckbox',
    props: {
        name: {
            type: String,
            required: true,
        },
        value: {
            type: Boolean,
            required: false,
            default: undefined,
        },
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: false,
            default: undefined,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        isInvalid: {
            type: Boolean,
            required: false,
            default: false,
        },
        message: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    model: {
        prop: 'value',
        event: 'update:value',
    },
    emits: [
        'update:value',
    ],
    setup: function (props, _a) {
        var emit = _a.emit;
        var idSuffix = idGenerator++;
        var iconName = computed(function () {
            if (props.value == null) {
                return 'toggle-checkbox-indeterminate-filled';
            }
            else if (props.value) {
                return 'toggle-checkbox-checked-filled';
            }
            else {
                return 'toggle-checkbox';
            }
        });
        function onChange(event) {
            var checked = event.target.checked;
            emit('update:value', checked);
        }
        return {
            iconName: iconName,
            isIconThemed: computed(function () { return props.value !== false; }),
            inputId: computed(function () { return "".concat(props.name, "-").concat(idSuffix); }),
            onChange: onChange,
        };
    },
    components: {
        SdsAlert: __vue_component__,
        SdsIcon: __vue_component__$1,
    },
});

export default script;
